import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Simulation } from 'src/app/core/models/simulation.model';
import { API } from '../../constants/api';
import { CONSTANTS } from '../../constants/constants';

@Injectable()
export class AMLConversionService {
  constructor(private httpClient: HttpClient) {}

  public amlToSimulation(amlFile: any): Observable<any> {
    const form = new FormData();
    form.append('amlFile', amlFile, amlFile.name);

    const headers = new HttpHeaders();
    headers.append('Content-Type', CONSTANTS.MULTIPART_FORM_DATA);
    headers.append('Accept', CONSTANTS.APP_JSON_TYPE);
    const options = { headers };

    return this.httpClient
      .post(API.AML_CONVERT_TO_JSON, form, options)
      .pipe(map((x) => x as Simulation))
      .pipe(catchError((error) => throwError(error)));
  }

  public jsonToAml(simulation: any): Observable<any> {
    try {
      delete simulation.lastUpdated;
    } catch (Exception) {}

    const payload = JSON.stringify(simulation);

    return this.httpClient
      .post(API.AML_CONVERT_TO_AML, payload, { responseType: 'text' })
      .pipe(catchError((error) => throwError(error)));
  }
}
